import { debounce } from './util'
import RouterManager from './components/RouterManager'
import NavbarManager from './components/NavbarManager'
import CarouselManager from './components/CarouselManager'
import ModalManager from './components/ModalManager'
import ScrollViewer from './components/ScrollViewer'
import ScrollAnimations from './components/ScrollAnimations'
import AnimationManager from './components/AnimationManager'
import ContactsManager from './components/ContactsManager'
import NewsletterManager from './components/NewsletterManager'
import DownloadsManager from './components/DownloadsManager'
import IubendaManager from './components/IubendaManager'

/**
 * @function makeTableResponsive
 * @description Script per rendere le tabelle responsive su mobile
 */
function makeTableResponsive() {
  if (!window.matchMedia('(max-width: 768px)').matches) return

  const containerClasses = ['.c-blog-article__text']

  containerClasses.forEach((containerClass) => {
    const containers = document.querySelectorAll(containerClass)
    containers.forEach((container) => {
      const tables = container.querySelectorAll('table')
      tables.forEach((table) => {
        const wrapper = document.createElement('div')
        wrapper.classList.add('table-responsive')
        const tableClone = table.cloneNode(true)
        wrapper.appendChild(tableClone)
        table.parentNode.replaceChild(wrapper, table)
      })
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className = 'js'

  if (window.matchMedia('(min-width: 1024px)').matches) {
    ScrollAnimations.hideDOM()
    ScrollAnimations.init()
    AnimationManager.hidePage()
  }

  RouterManager.init()
  NavbarManager.init()
  CarouselManager.init()
  ModalManager.init()
  ScrollViewer.init()
  AnimationManager.init()
  ContactsManager.init()
  NewsletterManager.init()
  DownloadsManager.init()
  IubendaManager.init()

  makeTableResponsive()
})

window.addEventListener('resize', debounce(() => {
  AnimationManager.manageVideo()
}, 250))

window.addEventListener('load', () => {
  AnimationManager.initLoad()
})
